// extracted by mini-css-extract-plugin
module.exports = {"custom-modal-style":"AddCuratedSetDialog_custom-modal-style__1DZfG","header":"AddCuratedSetDialog_header__1QnoW"};